import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "table table-striped border-light" }
const _hoisted_2 = { colspan: "2" }
const _hoisted_3 = { class: "mb-0 text-center text-capitalize-first" }
const _hoisted_4 = { class: "text-capitalize-first" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "text-capitalize-first" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "text-capitalize-first" }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { class: "text-capitalize-first" }
const _hoisted_11 = { key: 3 }
const _hoisted_12 = { class: "text-capitalize-first" }
const _hoisted_13 = { style: {"white-space":"pre-line"} }
const _hoisted_14 = { class: "text-capitalize-first" }
const _hoisted_15 = { class: "text-capitalize-first" }
const _hoisted_16 = { class: "text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_ExternalNspkSender = _resolveComponent("ExternalNspkSender")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        _createElementVNode("th", _hoisted_2, [
          _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.helper.trans('labels.external_transaction')), 1)
        ])
      ])
    ]),
    _createElementVNode("tbody", null, [
      _createElementVNode("tr", null, [
        _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.helper.trans('labels.tx_id')), 1),
        _createElementVNode("td", null, [
          _createTextVNode(_toDisplayString(_ctx.transaction.txId) + " ", 1),
          _createVNode(_component_copy_button, {
            value: _ctx.transaction.txId
          }, null, 8, ["value"])
        ])
      ]),
      (_ctx.transaction?.data.txNum)
        ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
            _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.helper.trans('labels.tx_num')), 1),
            _createElementVNode("td", null, [
              _createTextVNode(_toDisplayString(_ctx.transaction?.data.txNum) + " ", 1),
              _createVNode(_component_copy_button, {
                value: _ctx.transaction?.data.txNum
              }, null, 8, ["value"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.transaction?.data.paymentSystemTransferNum)
        ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
            _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.helper.trans('labels.paymentSystemTransferNum')), 1),
            _createElementVNode("td", null, [
              _createTextVNode(_toDisplayString(_ctx.transaction?.data.paymentSystemTransferNum) + " ", 1),
              _createVNode(_component_copy_button, {
                value: _ctx.transaction?.data.paymentSystemTransferNum
              }, null, 8, ["value"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.transaction?.data.sender)
        ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
            _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.helper.trans('labels.sender')), 1),
            _createElementVNode("td", null, [
              _createVNode(_component_ExternalNspkSender, {
                value: _ctx.transaction?.data.sender
              }, null, 8, ["value"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.transaction?.data.raw)
        ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
            _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.helper.trans('labels.sender')), 1),
            _createElementVNode("td", null, [
              _createElementVNode("pre", null, [
                _cache[0] || (_cache[0] = _createTextVNode("          ")),
                _createElementVNode("code", _hoisted_13, "\n              " + _toDisplayString(_ctx.transaction?.data.raw) + "\n          ", 1),
                _cache[1] || (_cache[1] = _createTextVNode("\n        "))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("tr", null, [
        _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.helper.trans('labels.service')), 1),
        _createElementVNode("td", null, _toDisplayString(_ctx.transaction.service), 1)
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.helper.trans('labels.status')), 1),
        _createElementVNode("td", null, _toDisplayString(_ctx.transaction.status), 1)
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.helper.trans('labels.date')), 1),
        _createElementVNode("td", null, _toDisplayString(_ctx.dateHelper.format(_ctx.transaction.updatedAt)), 1)
      ])
    ])
  ]))
}